<template>
  <v-btn
    :color="color"
    :outlined="outlined"
    :rounded="rounded"
    :style="cssProps"
    :disabled="disabled"
    :height="height"
    :width="width"
    :text="text"
    :loading="loading || requestLoading"
    depressed
    class="font-weight-medium subheading"
    :small="small"
    v-on="on"
    @click="onClick($event)"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    backgroundColor: { type: String, default: null },
    color: { type: String, default: 'primary' },
    darkText: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    on: { type: Object, default: null },
    small: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    request: { type: Function, default: null },
    height: { type: String, default: null },
    width: { type: String, default: null },
    rounded: { type: Boolean, default: false },
    setStyle: { type: Object, default: null }
  },
  data() {
    return {
      requestLoading: false
    }
  },
  computed: {
    cssProps() {
      return {
        color: this.darkText
          ? this.$vuetify.theme.themes.light.dark
          : this.$vuetify.theme.themes.light.white,
        'background-color': this.backgroundColor,
        ...this.setStyle
      }
    }
  },
  methods: {
    async onClick(evt) {
      if (this.request && this.request instanceof Function) {
        this.requestLoading = true
        await this.request.call()
        this.requestLoading = false
        this.$emit('click', evt)
      }
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  text-transform: none !important;
}
</style>
